/* eslint-disable */
import {
  makeStyles,
  RACCOLOR,
  RACSelect,
  RACTextConversationMessage,
  RACTextMessageInput,
  Typography,
  RACDateTimeLabel
} from '@rentacenter/racstrap';
import i18n from 'i18next'; // Import i18next
import React, { useEffect, useState, useRef, useContext } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import {
  TextConversationProvider,
  useTextConversation,
  useTextConversationActions,
} from '../../../context/TextConversationProvider/TextConversationProvider';
import { TextTemplateModal } from '../TextTemplate/TextTemplateModal';
import { ApiStateWrapper } from '../../../common/ApiStateWrapper/ApiStateWrapper';
import { formatPhoneNumber } from '../../../utils/utils';
import { StoreStateContext, useStoreDetails } from '../../../context/Store/StoreProvider';
import { useUserPermissions } from '../../../context/permission/PermissionsProvider';
import { useUserStateContext } from '../../../context/user/user-contexts';
import { FRCStoreType, RentACenter } from '../../../constants/constants';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
export interface TextConversationContentProps {
  onComponentDidMount: () => void;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    padding: '1rem 0.5rem 1rem 0.5rem',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    width: '100%',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    justifyContent: 'flex-start',
  },
  body: {
    width: '100%',
    overflowY: 'auto',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  noRecord: {
    display: 'flex',
    justifyContent: 'center !important',
  },
  headerItem: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    flex: 2,
  },
  headerItemValue: {
    color: `${RACCOLOR.INDEPENDENCE} !important`,
    whiteSpace: 'nowrap',
  },
  centered: {
    alignItems: 'center',
  },
  messageDate: {
    fontSize: `${theme.typography.pxToRem(12)} !important`,
    color: `${RACCOLOR.ARGENT} !important`,
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  leftMargin: {
    marginLeft: '.5rem',
  },
  type: {
    marginRight: '9px',
    marginLeft: '9px',
    alignItems: 'flex-start',
  },
   alignCenter:{
    textAlign: 'center',
    display:'block',
    color: `${RACCOLOR.ARGENT} !important`,
  }
}));
export const TextConversationContent = ({
  onComponentDidMount,
}: TextConversationContentProps) => {
  const classes = useStyles();
  const ref = useRef(null);
  const {
    phoneOptions,
    selectedPhoneOption,
    fullName,
    messages,
    isLoading,
    hasApiError,
    preferredLanguage,
    isCommunicationAllowed,
    isLegalHoldTextingAllowed,
  } = useTextConversation();
  const { t } = useTranslation();
    const {
      countryCode
    } = useCustomerDetails();
    const {enableCountryCode} = useContext(StoreStateContext);

  const { onPhoneOptionChanged, sendMessage } = useTextConversationActions();
  const [openTextTemplateModal, setOpenTextTemplateModal] = useState(false);
  const { store, textLanguage, setTextLanguage, isMXAccountManagement, DateTimeLocalization } = useStoreDetails();
  const countryAbb = store?.countryAbb?.toUpperCase();
  const regionCode = countryCode.filter((item)=> item.abbreviation == countryAbb)
  const { user } = useUserStateContext();
  // type LanguageContextType = {
  //   language: string;
  //   setLanguage: React.Dispatch<React.SetStateAction<string>>;
  // };
  const CoworkerName = `${user?.firstName} ${user?.lastName
    .charAt(0)
    .toUpperCase()}`;
  const companyName =
    store?.storeType === FRCStoreType
      ? `${CoworkerName} ${store?.storeNumber}`
      : RentACenter;
  const { hasAccessToTextTemplate, hasAccessToFreeFormText } =
    useUserPermissions();
  const DEFAULT_PRE_INPUT_TEXT = 'Templates';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onComponentDidMount, []);
  useEffect(() => {
    if (ref?.current) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      ref?.current?.scroll({
        top: Number.MAX_SAFE_INTEGER,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [messages, isLoading]);
  return (
    <div className={classes.root}>
      <div
        className={clsx(
          classes.body,
          isLoading || !messages.length || hasApiError ? classes.noRecord : null
        )}
        ref={ref}
      >
        <ApiStateWrapper
          loading={isLoading}
          hasApiError={hasApiError}
          response={messages}
          successContent={
            <>
              {messages.map(
                ({
                  textMessageId,
                  isSentByRAC,
                  message,
                  messageDate,
                  initials,
                  tooltipTitle,
                  tooltipSubTitle,
                }) => (
                  <div key={textMessageId}>
                    {
                      DateTimeLocalization ? 
                    <RACDateTimeLabel 
                      value={messageDate} 
                      country= {countryAbb} 
                      displayType ={'ShortDateTime24hrSeconds'} 
                      className={classes.alignCenter}
                      separator='-'
                    />
                    :
                    <Typography
                      align="center"
                      variant="body1"
                      className={classes.messageDate}
                    >
                      {messageDate}
                    </Typography>
                    }
                    <RACTextConversationMessage
                      key={textMessageId}
                      isOwnMessage={isSentByRAC}
                      avatarText={initials}
                      message={message}
                      tooltipTitle={tooltipTitle}
                      tooltipSubtitle={tooltipSubTitle}
                    />
                  </div>
                )
              )}
            </>
          }
        />
      </div>
      <div className={classes.header}>
        <div className={classes.headerItem}>
          <Typography align="left" variant="h5">
            {t('Name')}
          </Typography>
          <Typography
            className={classes.headerItemValue}
            variant="body1"
            align="left"
          >
            {fullName}
          </Typography>
        </div>
        <div className={clsx(classes.headerItem, classes.leftMargin)}>
          <Typography align="left" variant="h5">
            {t('Phone')}
          </Typography>
          <RACSelect
            isDisabled={
              !isCommunicationAllowed ||
              !isLegalHoldTextingAllowed ||
              !phoneOptions?.length
            }
            defaultValue={selectedPhoneOption?.value}
            options={phoneOptions.map((phone: any) => ({
              ...phone,
              label: formatPhoneNumber(t(phone.label), !isCommunicationAllowed || !isLegalHoldTextingAllowed, (enableCountryCode == 1 ? 
                (phone.countryCode ? phone.countryCode : (regionCode[0]?.countryCodeValue ?? '')): '')
),
            }))}
            onChange={(e: React.ChangeEvent<{ value: any }>) => {
              onPhoneOptionChanged(e.target.value);
            }}
          />
        </div>

        <div className={clsx(classes.headerItem, classes.centered, classes.type)}>
          <Typography align="center" variant="h5">
            {t('Type')}
          </Typography>
          <Typography
            align="center"
            className={classes.headerItemValue}
            variant="body1"
          >
            {isMXAccountManagement ? 'WhatsApp' : i18n.t(selectedPhoneOption?.phoneType)}
          </Typography>
        </div>
        <div className={classes.headerItem}>
          <Typography align="center" variant="h5">
            {t('Language')}
          </Typography>
          {isMXAccountManagement ? (<RACSelect
            defaultValue={textLanguage}
            options={[
              { label: 'English', value: 'en' },
              { label: 'Spanish', value: 'S' }
            ]}
            onChange={(e) => {
              const textConversationLang = e.target.value;
              setTextLanguage(textConversationLang)
            }}
          >
          </RACSelect>) :
            (<Typography
              align="center"
              className={classes.headerItemValue}
              variant="body1"
            >
              {i18n.t(preferredLanguage)}
            </Typography>)}
        </div>
      </div>
      {hasAccessToTextTemplate && hasAccessToFreeFormText && (
        <div>
          <Typography variant="h5">{t('Send Text To:')}</Typography>
          <Typography variant="body1">
            {t('Choose Text Template or Free Form Text')}
          </Typography>
        </div>
      )}
      <TextTemplateModal
        open={openTextTemplateModal}
        onClose={setOpenTextTemplateModal}
        preferredLanguageDesc={preferredLanguage}
        isCommunicationAllowed={
          isCommunicationAllowed && isLegalHoldTextingAllowed
        }
      />
      <RACTextMessageInput
        onSend={(e) => {
          if (isLegalHoldTextingAllowed) {
            sendMessage(`${e} - ${companyName}`);
          }
        }}
        onPreInputTextClicked={() =>
          hasAccessToTextTemplate &&
          isLegalHoldTextingAllowed &&
          setOpenTextTemplateModal(true)
        }
        isCommunicationAllowed={
          isCommunicationAllowed &&
          hasAccessToFreeFormText &&
          isLegalHoldTextingAllowed &&
          phoneOptions?.length > 0
        }
        preInputText={
          hasAccessToTextTemplate && phoneOptions?.length > 0
            ? t(DEFAULT_PRE_INPUT_TEXT)
            : ' '
        }
        inputPlaceholder= {t("Type the message here...")}
      />
    </div>
  );
};
